import React, { FunctionComponent } from 'react'

import { Avatar } from 'component-library-next'

import './index.scss'
import { IUser } from '../index'

type Props = { user: IUser }

export const ModernChatAvatar: FunctionComponent<Props> = ({ user }) => {
  return (
    <div className='modern-chat-avatar__wrapper'>
      <Avatar
        image={
          user.profilePictureUrl && user.profilePictureUrl !== ''
            ? user.profilePictureUrl
            : undefined
        }
        alt={
          user.firstName && user.lastName
            ? `${user.title ? user.title + ' ' : ''}${user.firstName} ${user.lastName}`
            : 'Profilbild'
        }
      />
    </div>
  )
}
